<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box no-display">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Leaving Certificate </strong>
                    <v-icon @click="onload" title="Reload list" dark color="yellow">mdi-reload</v-icon>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4" class="mt-3">
                    <v-combobox
                        class="no-display"
                        v-model="registration_no"
                        @change="checkHistory"
                        :loading="comp_load"
                        rounded
                        :items="stud_list"
                        label="Select Student"
                        item-text="name"
                        outlined
                        dense
                        prepend-icon="mdi-account-child-circle"
                    ></v-combobox>
                </v-col>
                <!-- <v-btn class="button mt-4" v-if="registration_no != null" @click="checkHistory()">Proceed</v-btn> -->
            </v-row>
            <!-- new code -->
            <div v-if="registration_no != null">
                <!-- collapse table code -->
                <template>
                    <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="panelheader">Account History </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-5">
                                <v-data-table :headers="headers_1" :items="ay_record" class="elevation-1 mytable" dense>
                                    <template v-slot:item.status="{ item }">
                                        <v-chip :color="getColor(item.status)" dark>
                                            {{ item.status }}
                                        </v-chip>
                                    </template>
                                </v-data-table>
                                <!-- table end -->
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-expansion-panels class="expapanel no-display" focusable inset>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="panelheader">Academic History </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-5">
                                <!-- table content -->

                                <v-data-table :headers="headers_2" :items="ay_record_div" dense class="elevation-1 mytable"> </v-data-table>
                                <!-- table end -->
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </template>

                <!-- tableData -- <br>{{ay_record}} -->
                <!-- collapse table code end -->
                <!-- radio button -->
                <v-row justify="center" dense class="no-display">
                    <v-radio-group v-model="fetch_gen_toggle" mandatory row class="radiobtn">
                        <v-radio label="Fetch LC" value="FETCH"></v-radio>
                        <v-radio label="Generate LC" value="GENERATE"></v-radio>
                    </v-radio-group>
                </v-row>
                <!-- radio button end -->
                <v-row justify="center" v-if="ay_record.length != 0">
                    <!-- {{ ay_record }}<br /> -->
                    <div class="fees no-display">
                        <span v-if="account_status" style="color: #4caf50;">Fees Clear </span>
                        <span v-else style="color: #f44336;">Fees Pending</span>
                    </div>
                </v-row>
            </div>
            <!-- end dd -->
        </v-card>
        <div v-if="registration_no != null">
            <!-- shiv code -->

            <!-- shiv code end -->

            <!-- FGT:{{ fetch_gen_toggle }} -->

            <!-- generate lc code -->
            <template v-if="fetch_gen_toggle == 'GENERATE'">
                <!-- Date starts -->
                <v-row justify="center" class="mt-3">
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense v-model="last_date_of_school" @blur="date = parseDate(last_date_of_school)" v-on="on" hint="Last Date of Leaving" prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>

                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense v-model="gen_date" @blur="date = parseDate(gen_date)" v-on="on" hint="Generation Date" prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>

                    <v-menu
                        ref="menu4"
                        v-model="menu4"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-bind="attrs"
                            dense
                            v-model="application_date"
                            @blur="date = parseDate(application_date)"
                            v-on="on"
                            hint="Date Of Application"
                            prepend-icon="event"
                            persistent-hint
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date_of_application"
                        no-title
                        @input="menu4 = false"
                        @change="setToText()"
                        ></v-date-picker>
                    </v-menu>
                    <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-bind="attrs"
                            dense
                            v-model="issue_date"
                            @blur="date = parseDate(issue_date)"
                            v-on="on"
                            hint="Date Of Issue"
                            prepend-icon="event"
                            persistent-hint
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        label="Issue Date"
                        v-model="date_of_issue"
                        no-title
                        @input="menu3 = false"
                        @change="setToText2()"
                        ></v-date-picker>
                    </v-menu>
                </v-row>
                <!-- Date ends -->
                <!-- L:{{ last_date_of_school }} -->
                <v-row justify="center" class="mt-3">
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="progress" rounded :items="dvt_prog" label="Select Progress" outlined dense persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="conduct" rounded :items="dvt_conduct" label="Select Conduct" outlined dense persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="remark" rounded :items="dvt_remark" label="Select Remark" outlined dense persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="reason" rounded :items="dvt_reason" label="Select Reason" outlined dense persistent-hint></v-combobox>
                    </v-col>
                </v-row>
                <v-row justify="center" class="mt-3">
                    <v-checkbox color="#0f2027" v-model="mark_inactive" label="Do You Want To Mark Student Inactive After Generating LC.?"></v-checkbox>
                </v-row>
                <v-row justify="center">
                    <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
                </v-row>
            </template>
            <!-- generate lc code end -->
            <template v-if="fetch_gen_toggle == 'FETCH'">
                <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>

                <br />
            </template>
            <div id="document1" class="printdiv" v-if="lc_data != null && org_id!='2'">
                <div class="header">
                    <v-row dense>
                        <div class="row">
                            <div class="col-3">
                                <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/vvp/vvp_logo.jpg" alt="" class="schlImg" />
                            </div>
                            <div class="col-9">
                                <center>
                                    <h4 class="trust-name">
                                        Bansilal Ramnath Agarwal Charitable Trust's
                                    </h4>                                
                                    <h2 class="schl-name">
                                            Vishwakarma Vidyalaya {{ org_id == '1' ? 'English' : 'Marathi' }}
                                            {{ lc_data.section_name ? lc_data.section_name : 'Primary' }}
                                    </h2>
                                    <div class="lcheading1">
                                        <h5 class="stretch2">An I.S.O. 21001 - 2018 Certified School</h5>
                                    </div>
                                </center>
                                <center>
                                    <span>666, Upper Indira Nagar, Bibwewadi, Pune 37</span>
                                    <br />
                                    <span v-if="lc_data.section_name =='Secondary'"> Phone: 9156286954 </span>
                                    <span v-else> Phone: 9156291049 </span>
                                    <span style="margin-left: 5px;">
                                        email: vvschool@vvp.edu.in
                                    </span>
                                </center>
                            </div>
                        </div>
                    </v-row>
                    <v-row justify="center" dense v-if="org_id == 2" translate="no" class="notranslate" style="font-size: 15px;">
                        <div><b>शाळा मान्यता क्र.- माध्यमिक एस.एस.एन.१०९५/५९०२ माशि .१  दि. २०/०१/१९९६ (माध्यम – मराठी)</b></div>
                    </v-row>
                    <v-row justify="center" dense v-if="org_id == 2" translate="no" class="notranslate" style="font-size: 15px;">
                        <div><b>ज्युनिअर कॉलेज – एच.एस.सी./ १७०३/(१९७/०३) उमाशि.१ दि.०९/०६/२००३ (माध्यम:सायन्स–इंग्रजी व कॉमर्स – मराठी )</b></div>
                    </v-row>
                </div>
                <hr class="hr-tag" />
                <hr class="hr-tag2" />
                <div class="">
                    <center>
                        <h3 class="stretch2">School Leaving Certificate</h3>
                    </center>
                </div>
                <center>
                    <span v-if="lc_data.section_name =='Secondary'" style="font-size: 13px;">
                        (According to rule No. 17 grant aid code) Secondary School Reg.No SSN / 1091 / 2888 / MS - 1 Date 3.2.92 
                    </span>
                    <span v-else-if="lc_data.section_name =='Higher Secondary'" style="font-size: 13px;">
                        (According to rule No. 17 grant aid code) Reg. No. HSC / 1708 / (181 / 08) HSE 25.7.2008
                    </span>
                    <span v-else>
                        (According to rule No. 17 grant aid code) School Reg.No VLS 1089 / CR 4578 Pri - 3 Date 3.2.1992
                    </span>
                </center>
                <div class="lcdata">
                    <hr class="hr-tag2" />
                    <v-col cols="12">
                        <div class="school-info">
                            <div class="row">
                                <div class="col-4">
                                    <span>LC No:</span>
                                    <span v-if="lc_data.certificate_no !== null && lc_data.certificate_no !== ''" class="dotted-underline">{{lc_data.certificate_no}}</span>
                                    <span v-else>----</span>
                                </div>
                                <div class="col-4">
                                    <span>PEN No:</span>
                                    <span class="dotted-underline" v-if="lc_data.pen_no !== null && lc_data.pen_no !== ''">{{lc_data.pen_no}}</span>
                                    <span v-else>----</span>
                                </div>
                                <div class="col-4">
                                    <span>GR.No:</span>
                                    <span class="dotted-underline"  v-if="lc_data.gr_number !== null && lc_data.gr_number !== ''">{{lc_data.gr_number}}</span>
                                    <span v-else>----</span>
                                </div>
                            </div>
                            <div class="row">
                                <!-- <div class="col-4">U-Dise No. : {{lc_data.udise_no}}</div> -->
                                <div class="col-4">
                                    <span>U-Dise No. : </span>
                                    <span class="dotted-underline"  v-if="lc_data.udise_no !== null && lc_data.udise_no !== ''">{{lc_data.udise_no}}</span>
                                    <span v-else>----</span>
                                </div>
                                <div v-if="lc_data.section_name =='Higher Secondary'" class="col-4">Board : HSC</div>
                                <div v-else class="col-4">Board : SSC</div>
                                <div v-if="lc_data.section_name !='Secondary'" class="col-4">Medium : {{lc_data.school_medium}}</div>
                                <div v-if="lc_data.section_name =='Secondary'" class="col-3">Index No.: 11.11.090</div>
                                <div class="col-4">
                                <span>Apaar ID : </span>   
                                <span class="dotted-underline" style="width: 143px;line-height: 0.6rem;"
                                        v-if="lc_data.apaar_id !== null && lc_data.apaar_id !== ''">{{lc_data.apaar_id}}</span>
                                    <span class="dotted-underline" style="width: 143px;line-height: 0.6rem;font-weight:bold"
                                        v-else>----</span>  
                                </div>  
                            </div>
                        </div>
                        <!-- <div class="row">
                    <div class="col-6">
                        <span>Student ID : </span>
                        <span class="dotted-underline">{{lc_data.reg_number}}</span>
                    </div>
                    <div class="col-6">
                        <span>UID No.(Aadhar No.) : </span>
                        <span class="dotted-underline">{{lc_data.aadhar_no}}</span>
                    </div>
                </div> -->
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table id="page">
                            <tbody class="tablebody">
                                <tr>
                                    <td>1</td>
                                    <td>Student Id</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.saral_id !== null && lc_data.saral_id !== ''">
                                            ID:{{ lc_data.saral_id}}
                                        </span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>2</td>
                                    <td>UID(Aadhaar No)</td>
                                    <td class="tdata2">
                                            <span v-if="lc_data.aadhar_no !== null && lc_data.aadhar_no !== ''">{{ lc_data.aadhar_no }}</span>
                                            <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Name of the pupil in full</td>
                                    <td class="tdata2">
                                        <span><b>(Name) </b></span>
                                        <span v-if="lc_data.first_name !== null && lc_data.first_name !== ''">{{ lc_data.first_name }}</span>
                                        <span v-else>----</span>

                                        <span><b>(Father's Name) </b></span>
                                        <span v-if="lc_data.middle_name !== null && lc_data.middle_name !== ''">{{lc_data.middle_name}}</span>
                                        <span v-else>----</span>

                                        <span><b>(Surname) </b></span>
                                        <span v-if="lc_data.last_name !== null && lc_data.last_name !== ''">{{lc_data.last_name}}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Mother's Name</td>
                                    <td class="tdata2"> 
                                        <span v-if="lc_data.mother_first_name !== null && lc_data.mother_first_name !== ''">{{ lc_data.mother_first_name }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Nationality</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.nationality  !== null && lc_data.nationality  !== ''">{{ lc_data.nationality  }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Mother Tongue</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.mothertoungue  !== null && lc_data.mothertoungue  !== ''">{{ lc_data.mothertoungue  }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>Religion and Caste-Subcaste</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.religion !== null && lc_data.religion !== ''">{{ lc_data.religion }}</span>
                                        <span v-else>----</span>
                                        -
                                        <span v-if="lc_data.caste !== null && lc_data.caste !== ''">{{ lc_data.caste }}</span>
                                        <span v-else>----</span>
                                        -
                                        <span v-if="lc_data.subcaste !== null && lc_data.subcaste !== ''">{{ lc_data.subcaste }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>8</td>
                                    <td>Place of Birth(Place,Tal-Dist,State,Country)</td>
                                    <td class="tdata2">
                                        Place - <span v-if="lc_data.birth_place !== null && lc_data.birth_place !== ''">{{ lc_data.birth_place }}</span><span v-else>----</span>,
                                        Taluka - <span v-if="lc_data.birth_taluka !== null && lc_data.birth_taluka !== ''">{{ lc_data.birth_taluka }}</span><span v-else>----</span>,
                                        Dist. - <span v-if="lc_data.birth_district !== null && lc_data.birth_district !== ''">{{ lc_data.birth_district }}</span><span v-else>----</span>,
                                        State - <span v-if="lc_data.birth_state !== null && lc_data.birth_state !== ''">{{ lc_data.birth_state }}</span><span v-else>----</span>,
                                        Country - <span v-if="lc_data.birth_country !== null && lc_data.birth_country !== ''">{{ lc_data.birth_country }}</span><span v-else>----</span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>9</td>
                                    <td>
                                        Date of Birth (in figure)
                                    </td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.dob_fig !== null && lc_data.dob_fig !== ''">{{ lc_data.dob_fig }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>10</td>
                                    <td>
                                        Date of Birth (in words)
                                    </td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.dob_words !== null && lc_data.dob_words !== ''">{{ lc_data.dob_words }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>11</td>
                                    <td>
                                        Date of Admission
                                    </td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.doa !== null && lc_data.doa !== ''">{{ lc_data.doa }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>12</td>
                                    <td>
                                        Standard
                                    </td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.admittedstandard !== null && lc_data.admittedstandard !== ''">{{ lc_data.admittedstandard }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>13</td>
                                    <td>Previous School Name - Std</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.last_school !== null && lc_data.last_school !== ''">{{ lc_data.last_school }}</span><span v-else>----</span> -
                                        <span v-if="lc_data.previousschoolpassingstandard !== null && lc_data.previousschoolpassingstandard !== ''">{{ lc_data.previousschoolpassingstandard }}</span><span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>14</td>
                                    <td>Progress</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.progress !== null && lc_data.progress !== ''">{{ lc_data.progress }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>15</td>
                                    <td>Conduct</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.conduct !== null && lc_data.conduct !== ''">{{ lc_data.conduct }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>16</td>
                                    <td>Date of Leaving School</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.last_date_of_school !== null && lc_data.last_date_of_school !== ''">{{ lc_data.last_date_of_school }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td>17</td>
                                    <td>Standard in which studying and since when(in Words)</td>
                                    <td class="tdata2">
                                        {{ lc_data.std_in_words }} and {{ lc_data.standard_since_when }}
                                    </td>
                                </tr> -->
                                <tr>
                                    <td>17</td>
                                    <td>Standard in which studying and since when</td>
                                    <td class="tdata2">
                                        <b> Std. </b>
                                        <span v-if="lc_data.standard !== null && lc_data.standard !== ''">{{ lc_data.standard }}</span><span v-else>----</span>
                                        <b> Since </b>
                                        <span v-if="lc_data.standard_since_when !== null && lc_data.standard_since_when !== ''">{{ lc_data.standard_since_when }}</span><span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>18</td>
                                    <td>Reason of Leaving School</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.reason !== null && lc_data.reason !== ''">{{ lc_data.reason }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>19</td>
                                    <td>Remarks</td>
                                    <td class="tdata2">
                                        <span v-if="lc_data.remark !== null && lc_data.remark !== ''">{{ lc_data.remark }}</span>
                                        <span v-else>----</span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <!-- lc table end -->
                    <span class="b2-span" style="margin-left: 15%;">Certified that the above information is in accordance with School General Register. </span><br />
                    <span class="tdata2 b2-span" style="margin-left: 5px;">Date :- {{ lc_data.gen_date }}</span><br />
                    <br />
                    <br />
                    <br />
                    <v-col cols="12" style="font-weight: bolder;">
                        <v-row dense>
                            <v-col cols="12" md="4" sm="4"><center><span class="b2-span">Class Teacher</span></center> </v-col>
                            <v-col cols="12" md="4" sm="4">
                             <center><span class="b2-span">Clerk</span></center>
                            </v-col>
                            <v-col cols="12" md="4" sm="4">
                                <center>
                                    <span class="b2-span">Headmistress</span> <br />
                                    <!-- <span class="b2-span"> {{ org_basic_data.school_name }}</span> -->
                                </center>
                            </v-col>
                        </v-row>
                    </v-col>
                </div>
            </div>
            <!-- lc data code end -->

              <!-- marathi template-->
              <div id="document1" class="printdiv" v-if="lc_data != null && org_id!='1'">
                <div class="header">
                    <v-row dense>
                        <div class="row">
                            <div class="col-3">
                                <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/vvp/vvp_logo.jpg" alt="" class="schlImg" />
                            </div>
                            <div class="col-9">
                                <center>
                                    <h4 class="trust-name">
                                        {{org_basic_data.trust_name}}
                                    </h4>                                
                                    <h2 class="schl-name">
                                           {{lc_data.school_name_by_section}}
                                    </h2>
                                    <div class="lcheading1">
                                        <h5 class="stretch2">आय.एस.ओ. 21001 - 2018 प्रमाणित शाळा</h5>
                                    </div>
                                </center>
                                <center>
                                    <span>{{org_basic_data.address}}</span>
                                    <br />
                                    <span v-if="lc_data.section_name =='Secondary'"> Phone: 9156286954 </span>
                                    <span v-else> Phone: 9156291049 </span>
                                    <span style="margin-left: 5px;">
                                        email: vvschool@vvp.edu.in
                                    </span>
                                </center>
                            </div>
                        </div>
                    </v-row>
                    <v-row justify="center" dense v-if="org_id == 2" translate="no" class="notranslate" style="font-size: 12px;">
                        <b>शाळा मान्यता क्र.- माध्यमिक एस.एस.एन.१०९५/५९०२ माशि .१  दि. २०/०१/१९९६ (माध्यम – मराठी)</b>
                        <b>ज्युनिअर कॉलेज – एच.एस.सी./ १७०३/(१९७/०३) उमाशि.१ दि.०९/०६/२००३ (माध्यम:सायन्स–इंग्रजी व कॉमर्स – मराठी )</b>
                    </v-row>
                </div>
                <v-row dense>
                <div class="row">
                     <div class="col-4 pl-5">
                        <h5>U-Dise No. : <b>{{ lc_data.udise_no ? lc_data.udise_no : '----' }}</b></h5>
                    </div>
                    <div class="col-4">
                        <h5 style="margin-left: 40px;">बोर्ड :<span> एस.एस.सी. (महाराष्ट्र)</span>
                        <div>एच.एस.सी. (महाराष्ट्र)</div></h5>
                        <!-- <h5 style="margin-left: 70px;"></h5> -->
                    </div>
                    <div class="col-4">
                        <h5>Index No. : S १ १.११.०९१</h5>
                        <h5 style="margin-left: 67px;">J १ १. १५.०४५</h5>
                    </div>
                </div>
            </v-row>
            <hr class="hr-tag" />
            <hr class="hr-tag2" />
                <div class="lcheading2_marathi mr-5">
                <center>
                    <h3 class="stretch2">School Leaving Certificate</h3>
                </center>
            </div>
            <center>
                <span v-if="lc_data.section_name =='Secondary'" style="font-size: 12px;">
                   (माध्यमिक शाळा संचिता नियम क्र. १७ व परिशिष्ट ४ प्रमाणे)
                </span>
                <span v-else-if="lc_data.section_name =='Higher Secondary'" style="font-size: 12px;">
                    (माध्यमिक शाळा संचिता नियम क्र. १७ व परिशिष्ट ४ प्रमाणे)
                </span>
                <span v-else style="font-size: 13px;">
                 (माध्यमिक शाळा संचिता नियम क्र. १७ व परिशिष्ट ४ प्रमाणे)
                </span>
            </center>
                <div class="school-info">
                <div class="row">
                     <div class="col-6 pr-0 py-2">
                        <span>GR.No. :</span>
                        <span class="dotted-underline " style="width: 43px;line-height: 0.6rem;"
                            v-if="lc_data.gr_number !== null && lc_data.gr_number !== ''">{{lc_data.gr_number}}</span>
                        <span class="dotted-underline " style="width: 43px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                    <div class="col-6 pr-0 py-2">
                        <span>LC No: : </span>
                        <span class="dotted-underline" style="width: 109px;line-height: 0.6rem;"
                            v-if="lc_data.certificate_no !== null && lc_data.certificate_no !== ''">{{lc_data.certificate_no}}</span>
                        <span class="dotted-underline" style="width: 109px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                </div>
                <div class="row">
                     <div class="col-6 pr-0 py-2">
                        <span>PEN No. : </span>
                        <span class="dotted-underline" style="width: 222px;line-height: 0.6rem;"
                            v-if="lc_data.pen_no !== null && lc_data.pen_no !== ''">{{lc_data.pen_no}}</span>
                        <span class="dotted-underline" style="width: 222px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>

                     <div class="col-6 pr-0 py-2">
                    <span>Apaar ID :</span>   
                    <span class="dotted-underline" style="width: 133px;line-height: 0.6rem;"
                            v-if="lc_data.apaar_id !== null && lc_data.apaar_id !== ''">{{lc_data.apaar_id}}</span>
                        <span class="dotted-underline" style="width: 133px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>  
                    </div>     
                    <!-- <div v-if="lc_data.section_name !='Secondary'" class="col-4 py-1">माध्यम : {{lc_data.school_medium}}</div>
                    <div v-if="lc_data.section_name =='Secondary'" class="col-3 py-1">अनुक्रमांक.: ११.११.०९०</div> -->
                </div>
                <div class="row">
                    <div class="col-6 pr-0 py-2">
                        <span>Student ID :</span>
                        <span class="dotted-underline" style="width: 173px;line-height: 0.6rem;"
                            v-if="lc_data.udise_no !== null && lc_data.udise_no !== ''">{{lc_data.saral_id}}</span>
                        <span class="dotted-underline" style="width: 173px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                    <!-- <div v-if="lc_data.section_name =='Higher Secondary'" class="col-2 px-0 pt-2" style="margin-left: -20px;">बोर्ड : एच.एस.सी.</div> -->
                    <!-- <div v-else class="col-2 px-0 pb-0" style="margin-left: -20px;">बोर्ड : एस.एस.सी.</div> -->
                    <div class="col-6 pr-0 py-2">
                        <span>UID No.(Aadhaar No.) : </span>
                        <span class="dotted-underline" style="width: 95px;line-height: 0.6rem;"
                            v-if="lc_data.aadhar_no !== null && lc_data.aadhar_no !== ''">{{lc_data.aadhar_no}}</span>
                        <span class="dotted-underline" style="width: 95px;line-height: 0.6rem;font-weight:bold"
                            v-else>----</span>
                    </div>
                </div>
            </div>
            <hr class="hr-tag2" />
            <div class="stud-info">
                <div class="row">
                    <div class="col-12">
                        <span><b>Name of Pupil in full:</b></span>
                    
                    
                        <span><b>(Name) </b></span>
                        <span class="dotted-underline" style="width: 500px;"
                            v-if="lc_data.first_name !== null && lc_data.first_name !== ''">{{ lc_data.first_name
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 109px;font-weight:bold">----</span>
                    </div>

                </div>
                <div class="row">

                    <div class="col-6">
                        <span><b>(Father's Name) </b></span>
                        <span class="dotted-underline" style="width: 240px;"
                            v-if="lc_data.middle_name !== null && lc_data.middle_name !== ''">{{ lc_data.middle_name
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 239px;font-weight:bold">----</span>
                    </div>

                    <div class="col-6">
                        <span><b>(Surname) </b></span>
                        <span class="dotted-underline" style="width: 265px;"
                            v-if=" lc_data.last_name !==null && lc_data.last_name !==''">{{ lc_data.last_name }}</span>
                        <span v-else class=" dotted-underline" style="width: 265px;font-weight:bold">----</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>Mother Name (in full) : </b></span>
                        <span class="dotted-underline" style="width: 559px;"
                            v-if="lc_data.mother_first_name !== null && lc_data.mother_first_name !== ''">{{
                            lc_data.mother_first_name }}</span>
                        <span v-else class="dotted-underline" style="width: 559px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span><b>Nationality : </b></span>
                        <span class="dotted-underline" style="width: 249px;"
                            v-if="lc_data.nationality !== null && lc_data.nationality !== ''">{{ lc_data.nationality
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 249px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span><b> Mother Tongue : </b></span>
                        <span class="dotted-underline" style="width: 235px;"
                            v-if="lc_data.mothertoungue !== null && lc_data.mothertoungue !== ''">{{
                            lc_data.mothertoungue }}</span>
                        <span v-else class="dotted-underline" style="width: 235px;font-weight:bold">----</span>

                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <span><b>Religion : </b></span>
                        <span class="dotted-underline" style="width: 81px;"
                            v-if="lc_data.religion !== null && lc_data.religion !== ''">{{ lc_data.religion }}</span>
                        <span v-else class="dotted-underline" style="width: 81px;font-weight:bold">----</span>
                    </div>
                    <div class="col-5">
                        <span><b>Caste : </b></span>
                        <span class="dotted-underline" style="width: 240px;"
                            v-if="lc_data.caste !== null && lc_data.caste !== ''">{{ lc_data.caste }}</span>
                        <span v-else class="dotted-underline" style="width: 240px;font-weight:bold">----</span>
                    </div>
                    <div class="col-4">
                        <span><b>Sub-Caste : </b></span>
                        <span class="dotted-underline" style="width: 142px;"
                            v-if="lc_data.subcaste !== null && lc_data.subcaste !== ''">{{ lc_data.subcaste }}</span>
                        <span v-else class="dotted-underline" style="width: 142px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span><b>Birth Place : </b></span>
                        <span class="dotted-underline" style="width: 248px;"
                            v-if="lc_data.birth_place !== null && lc_data.birth_place !== ''">{{ lc_data.birth_place
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 248px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span><b>Tal : </b></span>
                        <span class="dotted-underline" style="width: 113px;"
                            v-if="lc_data.birth_taluka !== null && lc_data.birth_taluka !== ''">{{ lc_data.birth_taluka
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 113px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span><b>Dist : </b></span>
                        <span class="dotted-underline" style="width: 112px;"
                            v-if="lc_data.birth_district !== null && lc_data.birth_district !== ''">{{
                            lc_data.birth_district }}</span>
                        <span v-else class="dotted-underline" style="width: 112px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span class="ml-5"><b>State : </b></span>
                        <span class="dotted-underline" style="width: 287px;"
                            v-if="lc_data.birth_state !== null && lc_data.birth_state !== ''">{{ lc_data.birth_state
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 287px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span><b>Country : </b></span>
                        <span class="dotted-underline" style="width: 285px;"
                            v-if="lc_data.birth_country !== null && lc_data.birth_country !== ''">{{
                            lc_data.birth_country }}</span>
                        <span v-else class="dotted-underline" style="width: 285px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span> <b>Date of Birth (in figure) : </b></span>
                        <span class="dotted-underline" style="width: 540px;"
                            v-if="lc_data.dob_fig !== null && lc_data.dob_fig !== ''">{{ lc_data.dob_fig }}</span>
                        <span v-else class="dotted-underline" style="width: 540px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span> <b>Date of Birth (in words) : </b></span>
                        <span class="dotted-underline" style="width: 537px;"
                            v-if="lc_data.dob_words !== null && lc_data.dob_words !== ''">{{ lc_data.dob_words }}</span>
                        <span v-else class="dotted-underline" style="width: 537px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span> <b>Date of Admission : </b></span>
                        <span class="dotted-underline" style="width: 195px;"
                            v-if="lc_data.doa !== null && lc_data.doa !== ''">{{ lc_data.doa }}</span>
                        <span v-else class="dotted-underline" style="width: 195px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span> <b> Standard : </b></span>
                        <span class="dotted-underline" style="width: 274px;"
                            v-if="lc_data.admittedstandard !== null && lc_data.admittedstandard !== ''">{{
                            lc_data.admittedstandard }}</span>
                        <span v-else class="dotted-underline" style="width: 274px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <span> <b>Previous School Name : </b></span>
                        <span class="dotted-underline" style="width: 355px;"
                            v-if="lc_data.last_school !== null && lc_data.last_school !== ''">{{ lc_data.last_school
                            }}</span>
                        <span v-else class="dotted-underline" style="width: 355px;font-weight:bold">----</span>
                    </div>
                    <div class="col-3">
                        <span> <b> Std : </b></span>
                        <span class="dotted-underline" style="width: 125px;"
                            v-if="lc_data.previousschoolpassingstandard !== null && lc_data.previousschoolpassingstandard !== ''">{{
                            lc_data.previousschoolpassingstandard }}</span>
                        <span v-else class="dotted-underline" style="width: 125px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span> <b>Progress: </b></span>
                        <span class="dotted-underline" style="width: 257px;"
                            v-if="lc_data.progress !== null && lc_data.progress !== ''">{{ lc_data.progress }}</span>
                        <span v-else class="dotted-underline" style="width: 257px;font-weight:bold">----</span>
                    </div>
                    <div class="col-6">
                        <span> <b> Conduct : </b></span>
                        <span class="dotted-underline" style="width: 277px;"
                            v-if="lc_data.conduct !== null && lc_data.conduct !== ''">{{ lc_data.conduct }}</span>
                        <span v-else class="dotted-underline" style="width: 277px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b>Date of School Leaving : </b></span>
                        <span class="dotted-underline" style="width: 526px;"
                            v-if="lc_data.last_date_of_school !== null && lc_data.last_date_of_school !== ''">{{
                            lc_data.last_date_of_school }}</span>
                        <span v-else class="dotted-underline" style="width: 526px;font-weight:bold">----</span>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-12">
                        <span><b>12. Standard in which studying and since when(in Words) : </b></span>
                        <span class="dotted-underline">{{ lc_data.std_in_words }} and {{ lc_data.standard_since_when }}</span>
                    </div>
                </div> -->
                <div class="row">
                    <div class="col-12">
                        <span><b>Standard in which studying and since when: </b></span>
                        <!-- <span class="dotted-underline" style="width: 302px;">{{ lc_data.standard }} and {{ lc_data.standard_since_when }}</span> -->
                        <span style="width: 302px;">
                            <b> Std. </b>
                            <span class="dotted-underline"
                                v-if="lc_data.standard !== null && lc_data.standard !== ''">{{ lc_data.standard }}
                            </span>
                            <span v-else class="dotted-underline" style="font-weight: bold;">----</span>&nbsp;
                            <b> Since </b>
                            <span class="dotted-underline"
                                v-if="lc_data.standard_since_when !== null && lc_data.standard_since_when !== ''"> {{
                                lc_data.standard_since_when }}</span>
                            <span v-else class="dotted-underline" style="font-weight: bold;">----</span>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b> Reason of leaving school : </b></span>
                        <span class="dotted-underline" style="width: 511px;"
                            v-if="lc_data.reason !== null && lc_data.reason !== ''">{{ lc_data.reason }}</span>
                        <span v-else class="dotted-underline" style="width: 511px;font-weight:bold">----</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <span><b> Remark : </b></span>
                        <span class="dotted-underline" style="width: 634px;"
                            v-if="lc_data.remark !== null && lc_data.remark !== ''">{{ lc_data.remark }}</span>
                        <span v-else class="dotted-underline" style="width: 634px;font-weight:bold">----</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>Certified that the above information is in accordance with School General Register.
                            </b></span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <span><b>Date : {{ lc_data.gen_date }}</b></span>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <div class="row pt-2">
                    <div class="col-4">
                        <span>
                            <center><b>Class Teacher</b></center>
                        </span>
                    </div>
                    <div class="col-4">
                        <span>
                            <center><b>Clerk</b></center>
                        </span>
                    </div>
                    <div class="col-4">
                        <span>
                            <center><b>Headmistress</b></center>
                        </span>
                    </div>
                </div>
                <hr class="hr-tag2" />
                <div class="row" style="line-height: 1.2rem;">
                    <div class="col-1 pt-2 pb-1 ml-none">Note:</div>
                    <div class="col-11 pt-2 pb-1 notranslate" v-if="org_id == 2" translate="no">
                        <div>1)शाळा सोडतेवेळी देण्यात येणाऱ्या लिव्हिंग सर्टिफिकेटमध्ये करावयाची कोणतीही दुरुस्ती तांबड्या शाईने मुख्याध्यापकाने संक्षिप्त सहीनिशी करावी.</div>
                        <div>2)  शाळा सोडण्याच्या दाखल्यामध्ये अनधिकृतरित्या बदल केल्यास संबंधितांवर कायदेशीर कारवाई करण्यात येईल.</div>
                    </div>
                    <div class="col-11 pt-2 pb-1" v-else>
                        <div>1) Any changes in school leaving certificate should be carried out in red ink with the
                            initiation of the Headmistress</div>
                        <div>2) Any infringenment of this rule is liable to rustication or other suitable
                            punishment.</div>
                    </div>
                    
     
                </div>
            </div>
            </div>

            <br />
            <div v-if="lc_data != null">
                <div class="no-display" style="text-align: center;">
                    ----------------------------------Modify------------------------------------
                </div>
                <br />
                <v-row class="no-display">
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth in words" v-model.trim="lc_data.dob_words"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Last School" v-model.trim="lc_data.last_school"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Standard" v-model.trim="lc_data.standard"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Since when..." v-model.trim="lc_data.standard_since_when"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Caste" v-model.trim="lc_data.caste"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Sub Caste" v-model.trim="lc_data.subcaste"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Religion" v-model.trim="lc_data.religion"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth District" v-model.trim="lc_data.birth_district"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth Taluka" v-model.trim="lc_data.birth_taluka"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth State" v-model.trim="lc_data.birth_state"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth Country" v-model.trim="lc_data.birth_country"></v-text-field>
                    </v-col>
                </v-row>
                <center>
                    <v-btn @click="proceed" class="info">Proceed to print</v-btn>
                </center>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                mark_inactive: false,
                headers_1: [
                    { text: "Academic Year", value: "ay" },
                    { text: "Paid", value: "paid" },
                    { text: "Balance", value: "balance" },
                    { text: "Status", value: "status" },
                ],
                headers_2: [
                    { text: "Academic Year", value: "ay" },
                    { text: "Roll No", value: "rollno" },
                    { text: "Div", value: "div" },
                    { text: "Std", value: "std" },
                    { text: "Total", value: "total" },
                    { text: "Present ", value: "present" },
                ],

                comp_load: false,
                fetch_loader: false,
                overlay: false,
                snackbar: false,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                registration_no: null,
                stud_list: [],
                ay_record: [],
                ay_record_div: [],
                account_status: false,
                dvt_prog: [],
                progress: null,
                dvt_conduct: [],
                conduct: null,
                dvt_reason: [],
                reason: null,
                dvt_remark: [],
                remark: null,
                fetch_gen_toggle: "FETCH",
                //////date
                last_date_of_school: "",
                gen_date: "",
                application_date: "",
                issue_date: "",
                date_of_application: new Date().toISOString().substr(0, 10),
                date_of_issue: new Date().toISOString().substr(0, 10),
                date: new Date().toISOString().substr(0, 10),
                date2: new Date().toISOString().substr(0, 10),
                menu1: false,
                menu2: false,
                menu3: false,
                menu4: false,
                nowDate: new Date().toISOString().slice(0, 10),
                ///
                lc_data: null,
                org_basic_data: null,
                condition: false,
                org_id : null
            };
        },
        watch: {
            date(val) {
                this.last_date_of_school = this.formatDate(this.date);
            },
            date2(val) {
                this.gen_date = this.formatDate(this.date2);
            },
            date_of_application(val) {
                this.application_date = this.formatDate(this.date_of_application);
                this.lc_data.date_of_application = this.application_date;
            },
            date_of_issue(val) {
                this.issue_date = this.formatDate(this.date_of_issue);
                this.lc_data.date_of_issue = this.issue_date;
            },
        },
        methods: {
            setToText() {
                this.lc_data.date_of_application = this.application_date;
            },
            setToText2() {
                this.lc_data.date_of_issue = this.issue_date;
            },
            proceed() {
                localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                // console.log(this.lc_data)
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                let routeData = this.$router.resolve({ name: "vvp-lc-print" });
                window.open(routeData.href, "_blank");
            },

            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}-${month}-${year}`;
            },

            // row_classes(item) {
            //     console.log("in function row");
            //     const rowClass = 'redrow'
            //     if (item.status === "pending" )
            //     return rowClass
            //     if(item.status === "clear")
            //     return "green"

            // },

            //     row_classes: function (item) {
            //         console.log("in fu");
            //     return item.status === 'pending' ? 'style-1' : 'style-2'

            // },

            getColor(status) {
                if (status === "pending") return "red";
                if (status === "clear") return "green";
                if (status === "NA") return "gray";
            },

            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },

            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onload() {
                this.ay_record = [];
                this.lc_data = null;
                this.org_basic_data = null;
                this.comp_load = true;
                axios
                    .post("/admission/getAllStudents")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.stud_list = res.data.all_stud_list;
                        } else {
                            this.showSnackbar("red", "Something went wrong.");
                        }
                        this.comp_load = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.comp_load = false;
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            checkHistory() {
                console.log("registration_no:", this.registration_no);
                this.ay_record = [];
                this.lc_data = null;
                this.org_basic_data = null;
                if (this.registration_no == null) {
                    this.showSnackbar("red", "Please select student");
                }
                this.overlay = true;
                axios
                    .post("/certificate/checkHistory", this.registration_no)
                    .then((res) => {
                        console.log("res", res.data);
                        if (res.data.flag == "YES") {
                            this.ay_record = res.data.ay_record;
                            this.account_status = res.data.account_status;
                            this.ay_record_div = res.data.ay_record_div;
                            this.dvt_prog = res.data.dvt_prog;
                            this.progress = this.dvt_prog[0];
                            this.dvt_conduct = res.data.dvt_conduct;
                            this.conduct = this.dvt_conduct[0];
                            this.dvt_reason = res.data.dvt_reason;
                            this.reason = this.dvt_reason[0];
                            this.dvt_remark = res.data.dvt_remark;
                            this.remark = this.dvt_remark[0];
                            this.condition = res.data.condition;
                            if (!this.condition) this.showSnackbar("red", res.data.condition_msg);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            genLC() {
                if (this.account_status == false) {
                    if (!confirm("Are You Sure You Want To generate LC as fees is pending...?")) return;
                }
                if (this.progress != null && this.conduct != null && this.last_date_of_school != "" && this.gen_date != "" && this.remark != null && this.reason != null && this.application_date != "" &&
                    this.issue_date != "") {
                    const formData = {
                        lid: this.registration_no.lid,
                        progress: this.progress,
                        conduct: this.conduct,
                        remark: this.remark,
                        reason: this.reason,
                        last_date_of_school: this.last_date_of_school,
                        gen_date: this.gen_date,
                        date_of_application: this.application_date,
                        date_of_issue: this.issue_date,
                        mark_inactive: this.mark_inactive,
                    };
                    this.overlay = true;
                    axios
                        .post("/certificate/genLC", formData)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.org_basic_data = res.data.org_basic_data;
                                this.lc_data = res.data.lc_data;
                                // if (this.lc_data.caste == null) {
                                //   alert("Caste is not enter ..");
                                // }
                                // this.showSnackbar("green", "User data fetched!!!");
                            } else {
                                this.showSnackbar("red", res.data.snackbar);
                                sessionStorage.setItem("error-trace", res.data.error_trace);
                            }
                            this.overlay = false;
                        })
                        .catch((error) => {
                            this.onerror(error);

                            this.overlay = false;
                        })
                        .finally(() => {
                            this.overlay = false;
                        });
                } else {
                    this.showSnackbar("red", "Please select/enter all data");
                }
            },
            fetchLC() {
                this.overlay = true;
                axios
                    .post("/certificate/fetchLC", this.registration_no)
                    .then(async(res) => {
                        if (res.data.flag == "YES") {
                            this.org_basic_data = res.data.org_basic_data;
                            this.lc_data = res.data.lc_data;
                            // this.showSnackbar("green", "User data fetched!!!");
                           
                            // if (this.org_id != '1') {   // Marathi template
                            //     await this.convertLCDataToMarathi();
                            // }

                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            // async convertLCDataToMarathi() {
            //  if (!this.lc_data) return;

            //     const fields = [
            //         "first_name",
            //         "middle_name",
            //         "last_name",
            //         "mother_first_name",
            //         "nationality",
            //         "mothertoungue",
            //         "religion",
            //         "caste",
            //         "subcaste",
            //         "birth_place",
            //         "birth_taluka",
            //         "birth_district",
            //         "birth_state",
            //         "birth_country",
            //         "dob_words",
            //         "last_school",
            //         "previousschoolpassingstandard",
            //         "progress",
            //         "conduct",
            //         "reason",
            //         "remark",
            //         "section_name",
            //         "standard",
            //         "standard_since_when",
            //         "certificate_no",
            //         "aadhar_no",
            //         "dob_fig",
            //         "last_date_of_school",
            //         "section_name",
            //         "gen_date"
            //     ];

            //     for (let field of fields) {
            //         let value = this.lc_data[field];
            //         if (!value) continue;

            //         if (field === "standard" && /^[IVXLCDM]+$/i.test(value)) {
            //             value = value + " class";
            //         }

            //         let translated = await this.translateToMarathi(value);

            //         if (field === "standard") {
            //             translated = translated.replace("इयत्ता ", "").trim();
            //         }

            //         translated = this.convertToMarathiNumber(translated);
            //         this.lc_data[field] = translated;
            //     }
            // },
            // convertToMarathiNumber(value) {
            //     if (!value) return "";

            //     return value.toString().replace(/\d/g, d =>
            //         String.fromCharCode(d.charCodeAt(0) + 2358)
            //     );
            // },
            // async translateToMarathi(text) {
            //     if (!text) return "";

            //     try {
            //         const res = await fetch(
            //             "https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=mr&dt=t&q=" +
            //             encodeURIComponent(text)
            //         );

            //         const data = await res.json();

            //         return data[0].map(item => item[0]).join("");
            //     } catch (e) {
            //         console.error("Translation error:", e);
            //         return text;
            //     }
            // }
        },
        mounted() {
            localStorage.setItem("lc_data", null);
            localStorage.setItem("org_basic_data", null);
            localStorage.setItem("last_date_of_school", "");
            this.org_id = localStorage.getItem("EPS-org-id");
            this.onload();
            this.last_date_of_school = this.formatDate(this.date);
            this.gen_date = this.formatDate(this.date2);
            this.application_date = this.formatDate(this.date_of_application);
            this.issue_date = this.formatDate(this.date_of_issue);
        },
    };
</script>
<style scoped>
    .scroll {
        overflow-x: scroll;
    }
    .mytable1 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .mytable /deep/ thead th {
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
        background: #83a4d4; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #265fb1, #b6fbff); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #265fb1, #b6fbff); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    /* @media (min-width: 320px) {
    td,
    th {
      display: table-cell !important;
      font-size: small;
    }
    td + td,
    th + th {
      width: auto;
      font-size: small;
    }
  } */
    /* v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: medium;
  } */

    .expapanel {
        width: 93%;
        margin-left: 3%;
    }

    .panelheader {
        /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
        color: white !important;
        background: #83a4d4; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3); /* Chrome 10-25, Safari 5.1-6 */
        /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        font-size: 16px;
        background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
    }

    .fees span {
        font-size: 23px;
        font-weight: 600;
    }

    /* .radiobtn{
    display: inline !important;
  } */

    /* lc data css */
    .printdiv {
        border: 3px solid;
        border-color: black;
        height: auto;
        /* width: 944px; */
        /* margin-left: 5%; */
        /* margin-top: 5px; */
        width: auto;
        margin-left: 5%;
        margin-right: 5%;
    }
    .header {
        /* border:2px solid;  */
        margin: 6px;
    }
    .trust-name {
        /* margin-left: 22%; */
        text-transform: uppercase;
    }
    .schl-name {
        font-size: 30px;
        text-transform: uppercase;
    }

    .adrs {
        /* margin-left: 33px; */
        margin-left: -10%;
    }

    .line1 {
        margin-left: -10%;
    }
    .line2 {
        margin-left: -10%;
    }

    .stdsection {
        margin-left: 30%;
        font-weight: bold;
        text-transform: uppercase;
        font-size: 15px;
    }

    .b-sapn {
        font-weight: 500;
        margin-left: 18px;
        font-size: 14px;
        display: block;
        margin-top: 2px;
    }

    .lcheading {
        /* border-block: 1px solid black; */
        border: 1px solid black;

        /* display: block; */
        /* width: 26%; */
        /* border-left: 1px solid black; */
        /* border-right: 1px solid black; */
        /* margin-left: 30%; */
        font-size: 17px;
        font-weight: 600;
        padding-left: 5px;
        padding-right: 5px;
        text-transform: uppercase;
    }

    .cardbody {
        /* border: 1px solid black; */
        width: 740px;
        display: inline-block;
        /* padding: 5px; */
        /* padding-top: 5px; */
        height: auto;
    }

    .schlImg {
        width: 84%;
        /* height: 60%; */
        margin-left: 10%;
    }
    .lcheading1 {
        /* margin-left: 16%; */
        width: 64%;
        border-radius: 17px;
        border: 1px solid black;
    }
    .hr-tag {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 100%;
        /* margin-left: -12px; */
        margin-bottom: 4px;
    }
    .lcheading2 {
        margin-left: 33%;
        width: 42%;
        border-radius: 6px;
        margin-top: 3px;
        border: 1px solid black;
        text-transform: uppercase;
    }
    .hr-tag2 {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 100%;
    }
    .dotted-underline {
        border-bottom: 1px dashed;
        /* line-height: 1.2rem; */
    }
    .school-info {
        line-height: 0.3rem;
    }
    .stud-info {
        line-height: 0.5rem;
    }

    .schlImg {
        /* width: 196px;
          height: 196px; */
        width: 87%;
        height: 60%;
        margin-left: 10px;
    }
    .tdata2 {
        font-weight: bolder;
    }

    #page tr,
    td {
        /* padding: 0;  */
        /* margin-left: 0px; */
        font-size: large;
        text-align: left;
    }
    /* lc data css end */

    /* print lc css */
    @media print {
        .b-sapn {
            font-weight: 500;
            /* margin-left: 15px; */
            font-size: 21px;
        }
        .schl-name {
            font-size: 35px;
            text-transform: uppercase;
        }
        .b2-span {
            font-weight: 500;
            margin-left: 18px;
            font-size: x-large;
        }
        .h3-span {
            /* margin-left: 15px; */
            font-size: 30px;
        }
        .h2-span {
            font-size: larger;
        }
        .card {
            border: none !important;
            font-size: large !important;
        }
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        body,
        tr,
        th,
        td {
            font-size: x-large !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            /* size: 11.5in 17.5in; */

            size: 15in 15in;
            /* size: 10in 18in; */

            /* size: 10in 17in; */
        }

        /* thead {
      font-weight: bold !important;
    } */
        /* table,
    tr,
    th {
      text-align: center !important;
      margin-top: none;
      padding: none !important;
      border-bottom: 1px solid black;
      border: 1px solid black;
    } */
    }
    /* print lc css end */

    .style-1 {
        background-color: rgb(215, 84, 44);
        font-weight: bolder;
    }
    .style-2 {
        background-color: rgb(61, 219, 21);
    }
    span.stretch {
        display: inline-block;
        -webkit-transform: scale(1.5, 1); /* Safari and Chrome */
        -moz-transform: scale(1.3, 1); /* Firefox */
        -ms-transform: scale(1.5, 1); /* IE 9 */
        -o-transform: scale(1.5, 1); /* Opera */
        /* transform: scale(1.3,1); */
        /* margin-left: 25%; */
        font-size: 14px;
    }
    .stretch1 {
        display: inline-block;
        -webkit-transform: scale(1.3, 1); /* Safari and Chrome */
        -moz-transform: scale(1.3, 1); /* Firefox */
        -ms-transform: scale(1.5, 1); /* IE 9 */
        -o-transform: scale(1.5, 1); /* Opera */
        /* transform: scale(1.3,1); */
        /* margin-left: 25%; */
        font-size: 14px;
    }

    h3.stretch2 {
        display: inline-block;
        -webkit-transform: scale(2, 1); /* Safari and Chrome */
        -moz-transform: scale(1.5, 1); /* Firefox */
        -ms-transform: scale(1.5, 1); /* IE 9 */
        -o-transform: scale(1.5, 1); /* Opera */
    }
</style>
